// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import {commaFormat} from '../../../../utils/number';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import {colors} from '../../../../assets/styles/colors';
import type {
  ManualOrderProductOptionGroup,
  SelectedProductOptions,
  ValidationError,
} from '../../types/productOptions';

const useStyles = makeStyles(theme => ({
  optionItemName: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.grey800,
  },
  textInput: {
    '& .MuiInputBase-input': {
      fontSize: '0.875rem',
      padding: '.5rem !important',
    },
  },
}));

export type BaseOptionRendererProps = {
  group: ManualOrderProductOptionGroup,
  selectedProductOptions: SelectedProductOptions,
  currencySymbol: string,
  validationErrors?: ValidationError[],
  onOptionToggle: (groupId: string, optionId: string) => void,
  onTextChange: (groupId: string, optionId: string, value: string) => void,
  onQuantityChange: (
    groupId: string,
    optionId: string,
    quantity: number
  ) => void,
};

type Props = BaseOptionRendererProps;

function TextOptionRenderer({
  group,
  selectedProductOptions,
  currencySymbol,
  onOptionToggle,
  onTextChange,
}: Props) {
  const classes = useStyles();
  const groupId = group.id;

  return (
    <>
      {group.options.map(option => {
        if (!option.enabled) return null;
        const optionId = option.id;
        const selectedOption = selectedProductOptions[groupId]?.[optionId];

        return (
          <div key={optionId} style={{marginBottom: '16px'}}>
            <Typography
              className={classes.optionItemName}
              style={{marginBottom: '8px'}}
            >
              {option.storeProductOption.name}: +
              {commaFormat(parseFloat(option.price || 0), currencySymbol)}
            </Typography>
            <CustomTextField
              fullWidth
              size="small"
              multiline
              minRows={2}
              maxRows={4}
              className={classes.textInput}
              value={selectedOption?.textValue || ''}
              onChange={e => {
                if (!selectedOption?.selected && e.target.value) {
                  onOptionToggle(groupId, optionId);
                }
                onTextChange(groupId, optionId, e.target.value);
              }}
            />
          </div>
        );
      })}
    </>
  );
}

export default TextOptionRenderer;
